module.exports = __webpack_public_path__ + "img/top.046fa786.png";